module.exports = __webpack_public_path__ + "static/media/KZ_LOGO.8f84a286.svg";